import {NOTES_MODES} from '#/notes/components/definitions'
import domainRepositoryFactory from '#/notes/api/domainRepositoryFactory'
import noteRepositoryFactory from '#/notes/api/noteRepositoryFactory'
import noteTagRepositoryFactory from '#/notes/api/noteTagRepositoryFactory'
import noteTypeRepositoryFactory from '#/notes/api/noteTypeRepositoryFactory'
import referenceRepositoryFactory from '#/notes/api/referenceRepositoryFactory'
import settingRepositoryFactory from '#/notes/api/settingRepositoryFactory'
import userServiceFactory from '#/notes/api/userServiceFactory'

const getters = {
  noteListingQueries: (state) => ({
    search: state.currentSearch,
    userFilters: state.userFilters,
    pagination: state.currentPagination
  }),
  /**
   * Joins the noteTypes into the note list
   * @param {Array} state.noteRecords
   * @param {String} state.defaultNoteTypeRecord
   * @returns {Array} the notes array with the note_type field expanded
   */
  notes: ({noteRecords}) => noteRecords,
  /**
   * @param {Array} state.currentNoteRecord
   * @returns {Array} the currentNote
   */
  currentNote: ({currentNoteRecord}) => currentNoteRecord,
  domainByName: ({domains}) => currentDomainName => domains.find(domain => domain.name === currentDomainName),
  isEditMode: ({currentMode}) => currentMode === NOTES_MODES.EDIT,
  isDetailMode: ({currentMode}) => currentMode === NOTES_MODES.DETAIL,
  isListMode: ({currentMode}) => currentMode === NOTES_MODES.LIST,
  repositories: ({environment}) => ({
    domains: domainRepositoryFactory(environment),
    notes: noteRepositoryFactory(environment),
    noteTags: noteTagRepositoryFactory(environment),
    noteTypes: noteTypeRepositoryFactory(environment),
    references: referenceRepositoryFactory(environment),
    settings: settingRepositoryFactory(environment)
  }),
  domainsRepository: (_, {repositories}) => repositories.domains,
  notesRepository: (_, {repositories}) => repositories.notes,
  noteTagsRepository: (_, {repositories}) => repositories.noteTags,
  noteTypesRepository: (_, {repositories}) => repositories.noteTypes,
  referencesRepository: (_, {repositories}) => repositories.references,
  settingsRepository: (_, {repositories}) => repositories.settings,
  userService: ({environment}, _, rootState) => userServiceFactory(environment, rootState.authentication)
}

export default getters
